<template>
  <section class="grid" ref="grid">
    <div
      class="grid__item"
      v-for="(el, i) in projects"
      :data-order="gsap.utils.wrap(1, 7, i + 1)"
      :data-index="i + 1"
      :style="{ gridRow: calculateRow(i + 1) }"
      v-observe
    >
      <NuxtLink :to="`/works/${el.work.slug}`">
        <div class="grid__media-wrap" data-cursor-project>
          <!-- <WebGLMedia
            class="grid__media"
            :src="`${el.work?.data?.image?.url}&w=400`"
            :video="el.work?.data?.video"
            v-if="!$mq.isMobile"
          />
          -->

          <MotionParallax
            :speed="1"
            :fit-width="true"
            v-if="$mq.isMobileOrTablet"
          >
            <AppMedia
              class="grid__media"
              :src="`${el.work?.data?.image?.url}&w=750`"
              :video="el.work?.data?.video"
            />
          </MotionParallax>
          <AppMedia
            v-if="!$mq.isMobileOrTablet"
            class="grid__media"
            :src="`${el.work?.data?.image?.url}&w=750`"
            :video="el.work?.data?.video"
          />
        </div>
        <div class="grid__item__info">
          <div class="grid__item__index ff-r d-f">
            <span class="grid__number"> {{ renderIndex(i + 1, 2) }} </span>
          </div>

          <div class="grid__item__heading">
            <span class="grid__name fs-16">{{ el.work.data.name }}</span>
            <span class="grid__role ff-nr c-text-mid fs-16">{{
              el.work.data.role
            }}</span>
          </div>
        </div>
      </NuxtLink>
    </div>
  </section>
</template>

<script setup>
const { $mq } = useNuxtApp();

const props = defineProps({
  projects: { type: Array, default: null },
});

const grid = ref(null);

const { $gsap: gsap } = useNuxtApp();

const calculateRow = index => {
  const order = gsap.utils.wrap(1, 7, index);
  const block = Math.floor((index - 1) / 6);
  const rowOffsets = { 1: 1, 2: 1, 3: 2, 4: 2, 5: 3, 6: 4 };
  return block * 4 + rowOffsets[order];
};
</script>

<style lang="scss" scoped>
.grid {
  display: flex;
  flex-direction: column;
  gap: 20svh;
  margin-bottom: fluidMap($spacing, 180);
  margin-left: auto;
  margin-right: auto;
  max-width: 100vw;
  will-change: transform;

  @include mq(desktop) {
    display: grid;
    gap: var(--gutter);
    grid-template-columns: repeat(var(--columns), 1fr);
    max-width: var(--width);
    row-gap: calc(var(--offset-double) * 2);
  }
}

.grid__item {
  cursor: pointer;
  opacity: 0;
  width: auto;
  will-change: transform;

  @include mq(desktop) {
    &[data-order='3'] {
      grid-column: 1 / 3;
    }
    &[data-order='4'] {
      grid-column: 6 / 8;
    }
    &[data-order='5'] {
      grid-column: 4 / 6;
    }
    &[data-order='6'] {
      grid-column: 1 / 3;
    }
    &[data-order='1'] {
      grid-column: 4 / 6;
    }
    &[data-order='2'] {
      grid-column: 6 / 8;
    }
  }
}

.grid__item__index {
  display: flex;
  font-size: 0.9em;
  width: 6ch;
}

.grid__number {
  display: flex;
}

.grid__name {
  margin-bottom: 0.1em;
  @include mq(desktop) {
    display: block;
  }
}

.grid__item__info {
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  margin-top: 1.25rem;
  padding: 0 var(--offset);

  @include mq(desktop) {
    align-items: baseline;
    display: grid;
    gap: var(--gutter);
    grid-template-columns: 0.2fr 1fr;
    justify-content: flex-start;
    overflow: hidden;
    padding: 0;
  }
}

.grid__item__heading {
  display: flex;
  justify-content: space-between;
  width: 100%;

  @include mq(desktop) {
    flex-direction: column;
  }
}

.grid__media {
  aspect-ratio: 1;
  background: var(--c-text-alt);
  display: flex;
  filter: brightness(1) saturate(1);
  overflow: hidden;
  transform: scale(1);
  transition: filter 0.75s ease(outExpo);
  width: 100%;
  z-index: 2;

  @include hover {
    .grid__media-wrap:hover & {
      filter: brightness(0.5) saturate(0);
    }
  }

  @include mqDown(desktop) {
    aspect-ratio: 1;
  }

  &:deep(img),
  &:deep(video) {
    object-fit: cover;
  }
}

.grid__media-wrap {
  aspect-ratio: 1;
  background: #eaeaea;
  clip-path: inset(0);
  display: flex;
  object-fit: cover;
  overflow: hidden;
  position: relative;
  z-index: 1;

  &:deep(.pr-t) {
    width: 100%;
  }

  @include mqDown(desktop) {
    aspect-ratio: 1;
  }
}
</style>
